<template>
  <div class="tgh-comp-address">
    <p class="tgh-address">
      <router-link to="/maps">Jl. Taman Setia Budi II No.497-498, Kuningan, <br>Setia Budi, Jakarta Selatan 12910</router-link>
    </p>
    <ul class="tgh-sosmed-mobile d-flex d-sm-none">
        <li>
            <a :href="(sosmed.facebook) ? sosmed.facebook : 'https://web.facebook.com/tengahbystbd/'" target="_blank">
                <img src="../assets/images/icon-fb.png" alt="">
            </a>
        </li>
        <li>
            <a :href="(sosmed.instagram) ? sosmed.instagram : 'https://www.instagram.com/tengahtengah_/'" target="_blank">
                <img src="../assets/images/icon-ig.png" alt="">
            </a>
        </li>
        <li>
            <a :href="(sosmed.email) ? 'mailto:'+sosmed.email : 'mailto:info@tengahtengah.com'" target="_blank">
                <img src="../assets/images/icon-envelope.png" alt="">
            </a>
        </li>
    </ul>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
export default {
  name: 'AddressNav',
  data() {
    return {
      sosmed : []
    }
  },
  methods : {
    getSosmed() {
      let vm = this
      let url = apiUrl+'/home/sosmed'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.sosmed = response.data.data
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    }
  },
  mounted() {
    this.getSosmed()
  }
}
</script>
